import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  EventEmitter
} from '@angular/core';
import {
  EnterpriseSearchService,
  WithSubscriptionComponent,
  ServiceType
} from '@sabstravtech/obtservices/angular';
import { FlightFilters, CarHireFilters, HotelFilters } from '@sabstravtech/obtservices/base';
import { TranslateService } from '@ngx-translate/core';

export enum CarHireFilterTypes {
  filterTravelPolicies = 'filterTravelPolicies',
  filterClasses = 'filterClasses',
  filterPreferences = 'filterPreferences',
  filterChains = 'filterChains',
  filterMakeModels = 'filterMakeModels',
  transmissionString = 'transmissionStringArray',
  fuelString = 'fuelStringArray'
}
@Component({
  selector: 'app-filter-pills',
  templateUrl: './filter-pills.component.html',
  styleUrls: ['./filter-pills.component.scss'],
  standalone: false
})
export class FilterPills extends WithSubscriptionComponent implements OnInit, OnChanges {
  @Input() filters: FlightFilters | CarHireFilters | HotelFilters;
  @Input() serviceType: ServiceType;
  @Input() filterTravelPolicies: string[] = [];
  @Input() filterClasses: string[] = [];
  @Input() filterPreferences: string[] = [];
  @Input() filterChains: string[] = [];
  @Input() filterMakeModels: string[] = [];
  @Input() transmissionStringArray: string[] = [];
  @Input() fuelStringArray: string[] = [];
  @Output() carHireRemoveFilter: EventEmitter<{ filterType: string; filter: string }> =
    new EventEmitter<{ filterType: string; filter: string }>();

  activeFilters: { filterType: string; filter: string; display: string }[];
  public searchParams: any;

  constructor(
    public searchService: EnterpriseSearchService,
    public translateService: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    if (this.serviceType === ServiceType.Flight) {
      this.searchParams = this.searchService.searches[ServiceType.Flight];
      this.subscribe(this.searchParams.results, () => {
        setTimeout(this.setupPills.bind(this), 0);
      });
    }
    if (this.serviceType === ServiceType.Hotel) {
      this.searchParams = this.searchService.searches[ServiceType.Hotel];
      this.subscribe(this.searchParams.results, () => {
        setTimeout(this.setupPills.bind(this), 0);
      });
    }
    if (this.serviceType === ServiceType.Car) {
      this.searchParams = this.searchService.searches[ServiceType.Car];
    }
  }

  ngOnChanges() {
    setTimeout(() => {
      this.setupPills();
    }, 0);
  }

  setupPills(): void {
    this.activeFilters = [];
    if (this.serviceType === ServiceType.Flight) {
      const filterTypes = Object.keys(this.filters);
      filterTypes.forEach((filterType) => {
        if (
          this.filters[filterType].max === undefined &&
          this.filters[filterType].min === undefined
        ) {
          const filters = Object.keys(this.filters[filterType]);
          filters.forEach((filter) => {
            if (this.filters[filterType][filter].selected) {
              this.activeFilters.push({
                filterType,
                filter,
                display: this.filters[filterType][filter].display
              });
            }
          });
        }
      });
    } else if (this.serviceType === ServiceType.Hotel) {
      const filterTypes = Object.keys(this.filters);
      filterTypes.forEach((filterType) => {
        if (
          filterType !== 'hotelName' &&
          this.filters[filterType].max === undefined &&
          this.filters[filterType].min === undefined
        ) {
          const filters = this.filters[filterType];
          filters.forEach((filter) => {
            this.activeFilters.push({
              filterType,
              filter,
              display: this.translateService.instant(filter)
            });
          });
        }
      });
    } else if (this.serviceType === ServiceType.Car) {
      this.filterClasses.forEach((filter) => {
        this.activeFilters.push({
          filterType: CarHireFilterTypes.filterClasses,
          filter,
          display: filter
        });
      });

      this.filterTravelPolicies.forEach((filter) => {
        this.activeFilters.push({
          filterType: CarHireFilterTypes.filterTravelPolicies,
          filter,
          display: filter
        });
      });

      this.filterPreferences.forEach((filter) => {
        this.activeFilters.push({
          filterType: CarHireFilterTypes.filterPreferences,
          filter,
          display: filter
        });
      });

      this.filterChains.forEach((filter) => {
        this.activeFilters.push({
          filterType: CarHireFilterTypes.filterChains,
          filter,
          display: filter
        });
      });

      this.filterMakeModels.forEach((filter) => {
        this.activeFilters.push({
          filterType: CarHireFilterTypes.filterMakeModels,
          filter,
          display: filter
        });
      });

      this.transmissionStringArray.forEach((filter) => {
        this.activeFilters.push({
          filterType: CarHireFilterTypes.transmissionString,
          filter,
          display: filter
        });
      });

      this.fuelStringArray.forEach((filter) => {
        this.activeFilters.push({
          filterType: CarHireFilterTypes.fuelString,
          filter,
          display: filter
        });
      });
    }
  }

  removeFilter(filterType: string, filter: string): void {
    if (this.serviceType === ServiceType.Flight) {
      this.filters[filterType][filter].selected = false;
      this.searchParams.applyFilters(this.filters as FlightFilters, this.searchParams.currentSort);
    }
    if (this.serviceType === ServiceType.Hotel) {
      this.searchParams.removeFilter(filter, filterType);
      this.searchParams.filterChange.next(true);
    }
    if (this.serviceType === ServiceType.Car) {
      this.carHireRemoveFilter.emit({ filterType, filter });
    }
  }
}
